/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from "react";
import { register } from "swiper/element/bundle";
import type { SwiperProps, SwiperSlideProps } from "swiper/react";

interface SwiperElement extends HTMLElement {
  initialize: () => void;
}

export function Swiper(props: SwiperProps & { children: React.ReactNode }) {
  const swiperRef = useRef<SwiperElement | null>(null);
  const { children, ...rest } = props;

  useEffect(() => {
    // Register Swiper web component
    register();

    // Ensure swiperRef.current is not null
    if (swiperRef.current) {
      // pass component props to parameters
      const params = {
        ...rest,
      };

      // Assign it to swiper element
      Object.assign(swiperRef.current, params);

      // initialize swiper
      swiperRef.current.initialize();
    }
  }, []);

  return (
    <swiper-container init={false} ref={swiperRef}>
      {children}
    </swiper-container>
  );
}

export function SwiperSlide(
  props: SwiperSlideProps & { children: React.ReactNode }
) {
  const { children, ...rest } = props;

  return <swiper-slide {...rest}>{children}</swiper-slide>;
}
